




















































import { Mixins, Component, Ref } from 'vue-property-decorator'
import MixinForm from 'components/presenter/item/topic/editor/MixinForm'
import FormSlide from 'components/presenter/item/topic/editor/FormSlide.vue'
import IntegerInput from 'components/IntegerInput.vue'
import AnswersEditor from 'components/presenter/item/topic/editor/AnswersEditor.vue'
import ModalDialog from 'components/modals/Dialog.vue'

@Component({
  components: {
    FormSlide,
    IntegerInput,
    AnswersEditor,
    ModalDialog
  }
})
export default class ItemTopicSlidesEditorFormRate extends Mixins(MixinForm) {

  @Ref()
  readonly rangeActionsDialog!: ModalDialog

  get rangeActions (): Json[] {
    return [{
      command: '',
      label: this.$t('slides.edit.rate.stars5').toString()
    }, {
      command: 'scale1to10',
      label: this.$t('slides.edit.rate.scale1to10').toString()
    }, {
      command: 'scale0to10',
      label: this.$t('slides.edit.rate.scale0to10').toString()
    }, {
      command: 'slider100',
      label: this.$t('slides.edit.rate.slider100').toString()
    }]
  }

  setRange (value: string) {
    this.rangeActionsDialog.hide()
    this.setOption('range', value)
  }
}
